// extracted by mini-css-extract-plugin
export default {"grid":"clearances_grid__-oJm-","table":"clearances_table__C4WXE","legend":"clearances_legend__13LZ6","stats":"clearances_stats__RKkg3","title":"clearances_title__EhkRQ"};